import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    chartContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        minHeight: '320px',
        minWidth: '320px',
        width: '100%',
        gap: '16px',
        padding: '16px',
        border: 'solid 1px #13131340',
        borderRadius: '8px',
        boxShadow: 'var(--shadow-card)',
        '& .apexcharts-legend': {
            justifyContent: 'center !important',
        },
        '& > div': {
            width: '100% !important',
        },
    },
}));
